import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fromConfiguration from '../../configuration/fromConfiguration';
import { computeArrayDiffs } from '../../services/diff';
import './LayoutComponent.scss';

// Produces infinte loop when reloading with HMR
// const LayoutComponent = (props) => {
//   const { configuration, components, ...rest } = props;
//   const makeComponents = () => {
//     return components.map(cfg => fromConfiguration(cfg));
//   };
//   const [Components, setComponents] = useState(makeComponents());
//   useEffect(() => {
//     console.log(props.components);
//     setComponents(makeComponents());
//   }, [props.components]);

//   const makeKey = (c, i) => {
//     return c.id || `layout-${i}`;
//   };
//   return (
//     <div className={classNames('grb-layout-ctnr', configuration.column ? 'column-layout' : 'row-layout', configuration.fullwidth && 'full-width', configuration.className)}>
//       {components.map((cfg, i) => {
//         const Component = Components[i];
//         return (
//           <div className="grb-layout-child" key={makeKey(cfg, i)}>
//             <Component {...rest} />
//           </div>
//         );
//       })}
//     </div>
//   );
// };

const getComponentID = (c, i) => `${i}`;
class LayoutComponent extends React.PureComponent {
  static getDerivedStateFromProps(props, state) {
    if ((props.components !== state.components)
          && (!state.components || computeArrayDiffs(state.components, props.components, getComponentID))) {
      return {
        components: props.components,
        Components: props.components.map(cfg => fromConfiguration(cfg)),
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { configuration, components, ...rest } = this.props;
    const { Components } = this.state;
    const makeKey = (c, i) => {
      return c.id || `layout-${i}`;
    };
    return (
      <div className={classNames('grb-layout-ctnr', configuration.column ? 'column-layout' : 'row-layout', configuration.childrenFull && 'grb-layout-ctnr-children-full', configuration.fullwidth && 'full-width', configuration.className)}>
        {this.state.Components.map((cfg, i) => {
          const Component = Components[i];
          return (
            <div className="grb-layout-child" key={makeKey(cfg, i)}>
              <Component {...rest} />
            </div>
          );
        })}
      </div>
    );
  }
}

LayoutComponent.propTypes = {
  configuration: PropTypes.shape({
    column: PropTypes.bool,
    fullwidth: PropTypes.bool,
    className: PropTypes.string,
    childrenFull: PropTypes.bool,
  }),
  components: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

LayoutComponent.defaultProps = {
  configuration: {},
};

export default LayoutComponent;
